import { render, staticRenderFns } from "./labelType.vue?vue&type=template&id=cce4c9fc&scoped=true&"
import script from "./labelType.vue?vue&type=script&lang=js&"
export * from "./labelType.vue?vue&type=script&lang=js&"
import style0 from "./labelType.vue?vue&type=style&index=0&id=cce4c9fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce4c9fc",
  null
  
)

export default component.exports